module.exports = __webpack_public_path__ + "img/thumb_15.d446a164.jpg";